import React, { Component } from 'react'

export default class IconTextStyle extends Component<any> {
    render() {
        return (
            <div className={this.props.className}>
                <span style={{ color: (this.props.color || '#000') }} className="icon-text-style"></span>
            </div>
        )
    }
}